import { useCallback } from 'react';
import { Empty, PasswordForm, ErrorAlert } from '@/shared/components';
import { usePasswordInfo } from '@/features/password';
import { Spinner } from '@heroui/react';
import { reactive } from '@/core/reactive/reactive';

export const Password = reactive.component(
  ({ services, monitors }) => {
    const info = usePasswordInfo();

    if (!info.isReady) return <Spinner label="Loading..." />;
    if (!info.isSuccess) return <ErrorAlert message={info.message} />;

    const handleSave = useCallback(
      password => {
        services.password.setPassword(info.token, password);
      },
      [services.password, info.token],
    );

    return (
      <Empty when={!info.isReady}>
        <PasswordForm
          label="Set Password"
          description="Create password to complete registration and activate your LiveFree ID."
          onComplete={handleSave}
          isLoading={monitors.setPassword.executing}
        />
      </Empty>
    );
  },
  {
    name: 'Password',
    monitors: services => [services.password.setPassword],
  },
);
